
import React, { forwardRef } from 'react';
import './Banner2.css';
import Banner2 from '../../Assets/banner2.png'; // Adjust the path if needed

const Banner = forwardRef((props, ref) => {
  return (
    <div ref={ref}>
    <div className="banner2-div">
        <img className="banner2" src={Banner2} alt="Banner2" />
    <div className="banner2-text">
    <div className="banner2-text-div">
        <h1 className="banner2-header-text">Power on <br/>the Go!</h1>
        <p className="banner2-text-body"> Running low on battery while out and about? HotCharge keeps you connected.</p>
        </div>
        <div>
                <div className="banner2-box"></div>
        <p className="banner2-text2-body"> “A single stop<br/>charging solution for all your devices!”</p>
        </div>
    </div>
    </div>
    <div className="banner2-div-mob">
    <div className="banner2-text-div">
        <h1 className="banner2-header-text">Power on the Go!</h1>
        <p className="banner2-text-body"> Running low on battery while out and about? HotCharge keeps you connected.</p>
        </div>
        <img className="banner2" src={Banner2} alt="Banner2" />
    <div className="banner2-text">
        <div >
                <div className="banner2-box"></div>
        <p className="banner2-text2-body"> A single stop charging solution for all your devices!</p>
        </div>
    </div>
    </div>
    </div>
  );
});

export default Banner;



// WEBPACK FOOTER //
// ./src/components/Banner2/Banner2.js